/*
 * @Author: fengyanjing
 * @Date: 2020-05-16 13:44:57
 * @Description:
 * @FilePath: /frontend/src/components/rebate/user-info/index.js
 */
/**
 * 个人资料（包括请求）
 */
export default {
  name: "user-info",

  props: {
    brandName: {
      required: false, //  授权品牌名称
      default: "",
    },
    userInfo: {
      required: true,
      type: Object,
      default: () => {
        return {
          name: "吴亦凡",
          levelText: "股东",
          headImg:
            "http://pics.sc.chinaz.com/files/pic/pic9/201509/apic14546.jpg",
        };
      },
    },
  },

  data() {
    return {
      defaultAvatr: require("./../../../assets/images/zpcommon/default-avatar.png"),
      defVal: "--",
    };
  },

  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
